import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "quickData" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bg-white" }, null, -1)
const _hoisted_3 = { class: "wp1200 flex" }
const _hoisted_4 = { class: "col1_2 weather flex" }
const _hoisted_5 = { class: "col1_2" }
const _hoisted_6 = { class: "weather" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "city" }, "Logatec", -1)
const _hoisted_8 = { class: "col1_2" }
const _hoisted_9 = { class: "temperature" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "celsium" }, "°C", -1)
const _hoisted_11 = { class: "flex timetable" }
const _hoisted_12 = { class: "col1_2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("LPP")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_bus" }, null, -1)
const _hoisted_16 = { class: "col1_2 parkings" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_parking" }, null, -1)
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "chartWrapper" }
const _hoisted_20 = { class: "col1_2 registration" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AdvancedGaugeChartHome = _resolveComponent("AdvancedGaugeChartHome")!
  const _component_SignUpRegistration = _resolveComponent("SignUpRegistration")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: { name: 'Weather' },
          class: "flex"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("quick_data.weather")), 1),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.weather)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([_ctx.weather.icon, 'weather_icon'])
                    }, null, 2),
                    _createElementVNode("span", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_ctx.weather.temperature), 1),
                      _hoisted_10
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              class: "flex",
              to: { name: 'FindPath' }
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("quick_data.timetable")), 1),
                  _hoisted_13,
                  _hoisted_14
                ]),
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_router_link, {
              class: "flex",
              to: { name: 'Parking' }
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("quick_data.parkings")), 1),
                _hoisted_17
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "airQuality",
        style: {"cursor":"pointer"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'AirQuality' })))
      }, [
        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("quick_data.aqi")), 1),
        _createElementVNode("div", _hoisted_19, [
          (_ctx.sensor?.measurements)
            ? (_openBlock(), _createBlock(_component_AdvancedGaugeChartHome, {
                key: 0,
                percentage: parseInt(_ctx.sensor.measurements?.index) || 0,
                min: 0,
                max: 200,
                bands: [
              {
                from: 0,
                to: 50,
                color: '#00a651',
                thickness: '45%',
              },
              {
                from: 50,
                to: 75,
                color: '#ffb000',
                thickness: '45%',
              },
              {
                from: 75,
                to: 100,
                color: '#fd8935',
                thickness: '45%',
              },
              {
                from: 100,
                to: 200,
                color: '#f05455',
                thickness: '45%',
              },
            ]
              }, null, 8, ["percentage"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.$t("quick_data.no_aqi")), 1)
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_SignUpRegistration)
      ])
    ])
  ]))
}